/* eslint-disable react/no-array-index-key */
import React from 'react';

import { PaymentItem, Wrap, Info, Dot, Name, Description, DescriptionValue } from './styles';

const CheckoutPaymentItem = ({
    className,
    onClick,
    paymentMethod,
    active,
    loading,
    single,
    dark,
}) => {
    return (
        <PaymentItem className={className} loading={loading} single={single} dark={dark}>
            <Wrap onClick={onClick} active={active}>
                <Info>
                    <Dot active={active} />
                    <Name dark={dark} active={active}>
                        {paymentMethod.name}
                    </Name>
                    {paymentMethod.description?.length > 0 && (
                        <Description>
                            {paymentMethod.description.map((value, index) => (
                                <DescriptionValue dark={dark} key={index} active={active}>
                                    {value}
                                </DescriptionValue>
                            ))}
                        </Description>
                    )}
                </Info>
            </Wrap>
        </PaymentItem>
    );
};

export default CheckoutPaymentItem;
